export const QCardReviewStatus = {
  REVIEWED: "reviewed",
  NOT_YET_REVIEWED: "not_yet_reviewed",
} as const;

export type QCardReviewStatusValue =
  (typeof QCardReviewStatus)[keyof typeof QCardReviewStatus];

export default interface QCardReviewStatusResponse {
  status: QCardReviewStatusValue | null;
  review_date: string | null;
  first_reviewed_at: string | null;
  opener_role: string | null;
  is_physician: boolean;
  met_cutoff: boolean | null;
  review_cutoff_time: string | null;
  timezone: string;
  can_calculate: boolean;
  async_physician_review_enabled: boolean;
}

export interface QCardReviewStatusRequestParams {
  emrPatientID: string;
  emrHospitalID: string;
  departmentName: string;
  timezone: string;
  qvHospitalID?: number | null;
}
